import { Link } from 'react-router-dom';
import { navLinks } from '@/mocks/navigation';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <span className="font-heading text-2xl font-bold tracking-tight">ky体育</span>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
              专业的在线体育竞技平台，提供丰富的体育赛事、实时数据、竞技资讯与互动体验。
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-4 text-white">快速导航</h4>
            <div className="flex flex-col gap-2">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-4 text-white">热门分类</h4>
            <div className="flex flex-col gap-2">
              {['足球赛事', '篮球赛事', '电竞赛事', '网球赛事', 'F1赛车', '斯诺克'].map((item) => (
                <span key={item} className="text-sm text-foreground-400 whitespace-nowrap">
                  {item}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-4 text-white">联系方式</h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-400">
              <span>邮箱：contact@ky-sports.com</span>
              <span>电话：400-888-6666</span>
              <span>地址：北京市朝阳区建国路88号</span>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 ky体育 版权所有 | 京ICP备2026000001号
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-white transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-white transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-white transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}